import { IProviderMenu } from '@sondermind/third-party/cms';

// Tricare provider's Cms slug — used by the fallback entry below and the footer override.
// Also maintained in the marketing site (sonder-homepage-gatsbyjs); a rename in Cms must be updated in both repos.
export const TRICARE_INSURANCE_SLUG = 'tricare-west';

/**
 * Static insurance options for footer links.
 * Used as fallback when API data is unavailable.
 */
export const FALLBACK_INSURANCES: IProviderMenu[] = [
  { title: "Aetna", slug: "aetna" },
  { title: "Alliant Health Plans", slug: "alliant-health-plans" },
  { title: "Anthem", slug: "anthem" },
  { title: "Blue Cross Blue Shield", slug: "bcbs" },
  { title: "CareFirst", slug: "carefirst" },
  { title: "CareSource", slug: "caresource" },
  { title: "Cigna", slug: "cigna" },
  { title: "ClaimDOC", slug: "claimdoc" },
  { title: "Denver Health Medical Plan", slug: "denver-health-medical-plan" },
  { title: "First Choice Health", slug: "first-choice-health" },
  { title: "Home State Health", slug: "home-state-health" },
  { title: "Kaiser Permanente", slug: "kaiser-permanente" },
  { title: "Medicare", slug: "medicare" },
  { title: "Ohio Healthy", slug: "ohiohealthy" },
  { title: "Optum", slug: "optum-united-eap" },
  { title: "Prime Health Services", slug: "prime-health" },
  { title: "Rocky Mountain Health Plans", slug: "rmhp" },
  { title: "Sana Benefits", slug: "sana-benefits" },
  { title: "Select Health", slug: "select-health" },
  { title: "Tricare", slug: TRICARE_INSURANCE_SLUG },
  { title: "United Healthcare", slug: "united-healthcare" }
];

/**
 * Static specialty options for footer links.
 * Used as fallback when API data is unavailable.
 */
export const FALLBACK_SPECIALTIES: IProviderMenu[] = [
  { title: 'ADHD', slug: 'adhd-therapy' },
  { title: 'Addiction', slug: 'addiction-therapy' },
  { title: 'Anger Management', slug: 'anger-management-therapy' },
  { title: 'Anxiety', slug: 'therapy-for-anxiety' },
  { title: 'Autism Spectrum Disorder', slug: 'autism-spectrum-therapy' },
  { title: 'Bipolar Disorder', slug: 'bipolar-disorder-therapy' },
  { title: 'Borderline Personality Disorder', slug: 'borderline-personality-disorder-therapy' },
  { title: 'Depression', slug: 'depression-therapy' },
  { title: 'Eating Disorders', slug: 'eating-disorder-therapy' },
  { title: 'Grief/Bereavement', slug: 'grief-therapy' },
  { title: 'OCD', slug: 'ocd-therapy' },
  { title: 'Psychosis', slug: 'psychosis-therapy' },
  { title: 'PTSD', slug: 'ptsd-therapy' },
  { title: 'Stress', slug: 'stress-therapy' },
  { title: 'Trauma', slug: 'trauma-therapy' },
  { title: 'Couples Therapy', slug: 'therapy-for-couples' },
  { title: 'Family Therapy', slug: 'family-therapy' },
  { title: 'Therapy for Veterans', slug: 'therapy-for-veterans' },
  { title: 'Teen Therapy', slug: 'teen-therapy' },
  { title: 'Therapy for LGBTQIA+', slug: 'lgbtqia-therapy' },
  { title: 'Gender Identity Therapy', slug: 'gender-identity-therapy' },
  { title: 'Intimacy Therapy', slug: 'intimacy-therapy' },
  { title: 'Phobia Therapy', slug: 'phobia-therapy' },
  { title: 'Pregnancy Therapy', slug: 'pregnancy-therapy' },
  { title: 'Sex Therapy', slug: 'sex-therapy' },
  { title: 'Somatic Therapy', slug: 'somatic-therapy' },
  { title: 'Traumatic Brain Injury Therapy', slug: 'traumatic-brain-injury-therapy' }
];
